import { Link } from 'gatsby'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { AppContext } from '../../../contexts/AppContext'


    const Dropdown = styled.div`
        font-family: ${props => props.theme.default.fonts.family};
        position: absolute;
        min-width: 300px;
        background-color: ${props => props.theme.default.colors.headerMenu};
    `

    const OptionList = styled.ul`
        list-style-type: none;
        margin: 0;
        padding: 0;
    `

    const Option = styled.li`
        padding: 20px 40px !important;
        font-size: 10pt;
        text-transform: uppercase;
        margin-bottom: 0px !important;
        cursor: pointer;
        color: ${props => props.theme.default.colors.darkTeal};

        &:hover {
            background-color: rgba(0,0,0,0.05)
        }
    `

    const Option2ndLevel = styled(Option)`
        padding: 20px 60px !important;
        color: ${props => props.theme.default.colors.darkTeal};
    `

    const MenuSection = styled.h4`
        font-size: 8pt;
        text-transform: uppercase;
        padding: 20px 40px 0 40px;
        margin: 0;
    `

    const MenuSectionText = styled.p`
        font-size: 8pt;
        padding-right: 40px;
        max-width: 250px;
        margin-left: 40px;
    `

export const SolutionsMenu = ({ open }) => {

    const { appState, sendEvent } = useContext(AppContext);

    return (
        open && <Dropdown>
            <MenuSection>{appState.i18n.header.privateSolutions}</MenuSection>
            <MenuSectionText>{appState.i18n.header.privateSolutions_description}</MenuSectionText>
            <OptionList>
                <Link to={"/solutions/private/powerpack"} onClick={() => sendEvent("Navigation", "Sidebar", "PowerPack Plan")}><Option>{appState.i18n.header.powerpack}</Option></Link>
                {/* <Link to={"/solutions/private/powerbox"} onClick={() => sendEvent("Navigation", "Sidebar", "PowerBox Plan")}><Option>{appState.i18n.header.powerbox}</Option></Link> */}
            </OptionList>
            <MenuSection>{appState.i18n.header.publicSolutions}</MenuSection>
            <MenuSectionText>{appState.i18n.header.publicSolutions_description}</MenuSectionText>
            <OptionList>
                <Link to={"/solutions/plans/"} onClick={() => sendEvent("Navigation", "Header", "Plans Comparison")}><Option>{appState.i18n.header.allPlans}</Option></Link>
                <Link to={"/solutions/plans/mobility"} onClick={() => sendEvent("Navigation", "Header", "Mobility Plan")}><Option2ndLevel>{appState.i18n.header.mobilityPlan}</Option2ndLevel></Link>
                <Link to={"/solutions/plans/residential"} onClick={() => sendEvent("Navigation", "Header", "Residential Plan")}><Option2ndLevel>{appState.i18n.header.residentialPlan}</Option2ndLevel></Link>
            </OptionList>
        </Dropdown>
    )
}
